export default __webpack_public_path__ + "static/sns-youtube-9814dfffba3b8774941b282d9bc0c74c.svg";